import styled from "styled-components";

type BackgroundType = { background: string };
type ColorType = { color: string };
type ButtonType = { background: string; color: string };

export const Container = styled.div<BackgroundType>`
    display: flex;
    flex-direction: column;
    background: ${(props) => props.background};
    border-radius: 16px;
    padding: 24px;
    gap: 28px;
    min-width: 320px;
`;

export const Title = styled.span<ColorType>`
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.color};
    line-height: 1.4;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
`;

export const CancelButton = styled.button<ColorType>`
    background: transparent;
    border: none;
    color: ${(props) => props.color};
    font-size: 15px;
    font-weight: 500;
    padding: 10px 16px;
    cursor: pointer;
    border-radius: 999px;

    &:hover {
        opacity: 0.85;
    }
`;

export const DiscardButton = styled.button<ButtonType>`
    background: ${(props) => props.background};
    color: ${(props) => props.color};
    border: none;
    font-size: 15px;
    font-weight: 600;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 999px;

    &:hover {
        opacity: 0.9;
    }
`;
